export default {
  apiBase: process.env.VUE_APP_API_BASE || '/api', // api、demodata、offline，其中offline模式，需要先从easy-mock导出数据，把文件夹命名为offline，放在nginx的html目录下面
  apiMode: process.env.VUE_APP_API_MODE || 'cors', // proxy、cors
  routerMode: 'hash', // history或者hash
  homeRouter: 'Mains',
  loginRouter: process.env.VUE_APP_LOGIN_ROUTER || 'Login',
  notificationKeep: 2,
  messageKeep: 3,
  aliveKeep: process.env.VUE_APP_WX_APP_ID ? 0 : 30 * 60, // 0表示关闭该功能
  checkFunCode: true,
  companyName: process.env.VUE_APP_COMPANY_NAME || '通莞金服'
}
